import { render, staticRenderFns } from "./SalonItem.vue?vue&type=template&id=35a3caf4&scoped=true"
import script from "./SalonItem.vue?vue&type=script&lang=js"
export * from "./SalonItem.vue?vue&type=script&lang=js"
import style0 from "./SalonItem.vue?vue&type=style&index=0&id=35a3caf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3caf4",
  null
  
)

export default component.exports